import { render, staticRenderFns } from "./facilityInformationAndPhoto.vue?vue&type=template&id=6b5d1806"
import script from "./facilityInformationAndPhoto.vue?vue&type=script&lang=js"
export * from "./facilityInformationAndPhoto.vue?vue&type=script&lang=js"
import style0 from "./facilityInformationAndPhoto.vue?vue&type=style&index=0&id=6b5d1806&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports